// extracted by mini-css-extract-plugin
module.exports = {"Title":"ReasonCard_Title__3ghF4","Description":"ReasonCard_Description__O6miy"};